import { create } from "zustand";
import type { Planting } from "../types";

interface PlantingState {
	modalOpen: boolean;
	editingItem: Planting | null;
	defaultOrganizationId: string | null;
}

interface PlantingActions {
	openCreateModal: (organizationId?: string) => void;
	openEditModal: (item: Planting) => void;
	closeModal: () => void;
}

type PlantingStore = PlantingState & PlantingActions;

export const usePlantingsStore = create<PlantingStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultOrganizationId: null,

	openCreateModal: (organizationId) => {
		set({ modalOpen: true, editingItem: null, defaultOrganizationId: organizationId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultOrganizationId: null });
	},
}));
